import { type ReactNode, use } from 'react';
import {
  DropdownContent,
  DropdownContentWrapper,
  DropdownStyled,
  TextFieldDescription,
} from './styles';
import { DropdownHeader } from './components/DropdownHeader/DropdownHeader';
import { DropdownContexts } from './context/DropdownContext';
import { withDropdownProvider } from './hooks/withDropdownProvider/withDropdownProvider';
import { DropdownSkeletonLoader } from './components/DropdownSkeletonLoader';

export const Dropdown = withDropdownProvider(({ children }: { children: ReactNode }) => {
  const { loading = false, maxItemsToShow, description } = use(DropdownContexts.props);
  const { open, dropdownRef } = use(DropdownContexts.useDropdown);

  return (
    <DropdownStyled ref={dropdownRef}>
      <DropdownHeader />
      <DropdownContentWrapper>
        {open && (
          <DropdownContent maxItemsToShow={maxItemsToShow}>
            {loading && <DropdownSkeletonLoader />}

            {!loading && children}
          </DropdownContent>
        )}
      </DropdownContentWrapper>
      {description && <TextFieldDescription>{description}</TextFieldDescription>}
    </DropdownStyled>
  );
});

export * from './types/dropdown';
export * from './components';
